import Auth from "@aws-amplify/auth";

export async function Init(): Promise<void> {
  const config = {
    stage: "beta",
    aws_cognito_region: "ap-southeast-2",
    aws_cognito_identity_pool_id: "ap-southeast-2:0e7a23f1-f153-4978-8869-d91eb1055474",
    aws_user_pools_id: "ap-southeast-2_2Wn6eQpNJ",
    aws_user_pools_web_client_id: "3d7urrod521u11ju9d7e7da4mq",
    Auth: {
      identityPoolId: "ap-southeast-2:0e7a23f1-f153-4978-8869-d91eb1055474",
      region: "ap-southeast-2",
      userPoolId: "ap-southeast-2_2Wn6eQpNJ",
      userPoolWebClientId: "3d7urrod521u11ju9d7e7da4mq",
    },
    oauth: {
      domain: "whs-safer-beta-au.auth.ap-southeast-2.amazoncognito.com",
      redirectSignIn: "https://beta.au.safer.whs.amazon.dev",
      redirectSignOut: "https://beta.au.safer.whs.amazon.dev",
      scope: ["openid", "profile"],
      responseType: "code",
    },
  };

  // BETA/LOCAL ONLY: the Hydra/Cypress integration test authenticates as a SAAM
  // service identity (svc-mw-...-midwaysaam) that has NO email. The identity
  // pool's authenticated role (AmazonQBusinessCognitoRole) requires an `Email`
  // session tag mapped from the token's `email` claim; with no email, the role
  // assume fails ("Invalid identity pool configuration") and Amplify emits
  // signIn_failure so the app never authenticates. The frontend does not use
  // identity-pool (IAM) credentials, so we drop the identity pool on beta/local
  // and let sign-in complete on the User Pool alone. Gamma/prod are unchanged.
  // Local/dev builds resolve beta to "test".
  const stage = "beta".toLowerCase();
  const skipIdentityPool = stage === "beta" || stage === "test";

  if (skipIdentityPool) {
    delete (config as { aws_cognito_identity_pool_id?: string })
      .aws_cognito_identity_pool_id;
    delete (config.Auth as { identityPoolId?: string }).identityPoolId;
  }

  Auth.configure(config);
}
